document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.accordion');

  [...accordions].forEach(accordion => {
    const accordionItems = accordion.querySelectorAll('.accordion-item');

    [...accordionItems].forEach(accordionItem => {
      const headerNodes = accordionItem.querySelectorAll('h3');
      const header = headerNodes[0];

      const button = document.createElement('button');
      button.innerText = header.innerText;
      button.id = uuidv4();

      header.innerText = '';

      header.appendChild(button);

      const contentNodes = accordionItem.querySelectorAll(
        '.wp-block-group__inner-container > div'
      );

      const content = contentNodes[0];

      content.id = uuidv4();

      content.setAttribute('hidden', '');
      content.setAttribute('aria-hidden', 'true');
      content.setAttribute('role', 'region');
      content.setAttribute('aria-labelledby', button.id);

      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', content.id);

      header.addEventListener('click', e => {
        button.setAttribute(
          'aria-expanded',
          button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
        );
        if (accordionItem.classList.contains('opened')) {
          accordionItem.classList.remove('opened');
          content.style.maxHeight = null;
        } else {
          closeAccordionItems(accordionItems);
          accordionItem.classList.add('opened');
          if (content.style.maxHeight) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        }
      });
    });
  });

  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function closeAccordionItems(accordionItems) {
    [...accordionItems].forEach(accordionItem => {
      accordionItem.classList.remove('opened');
      const contentNodes = accordionItem.querySelectorAll(
        '.wp-block-group__inner-container > div'
      );
      const content = contentNodes[0];
      content.style.maxHeight = null;
    });
  }
});
